import {doc} from './docs.js';
import ZGroups from '../custom/ZGroups.js';

doc(
    'groups',
    {
        '': ''
    },
    "Controls groups",
    () => 0,
    {
        inlets: 0
    });

export const groups = (obj) => {
    let _groups = new ZGroups(obj);
    return () => undefined;
};
